/*
 * Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BuildCheckToolComponent} from './components/build-check-tool/build-check-tool.component';
import {NetlistCompareComponent} from './components/netlist-compare/netlist-compare.component';
import {IdenticalConnectorComponent} from './components/identical-connector/identical-connector.component';
import {ExtractionCompareComponent} from './components/extraction-compare/extraction-compare.component';
import {BackToEsciComponent} from './components/back-to-esci/back-to-esci.component';
import {WelcomeComponent} from './components/welcome/welcome-component';
import {KtsComponent} from './components/kts/kts.component';
import {KtsEditorComponent} from './components/kts-editor/kts-editor.component';
import {ProgramRunsComponent} from './components/program-runs/program-runs.component';
import {VehicleBuildCompareComponent} from './components/vehicle-build-compare/vehicle-build-compare.component';
import {GpsRpoManagementComponent} from './components/gps-rpo-management/gps-rpo-management.component';
import {GpsTimingComponent} from './components/gps-timing/gps-timing.component';
import {RestrictedProgramsComponent} from './components/restricted-programs/restricted-programs.component';
import {KtsAdminComponent} from './components/kts-admin/kts-admin.component';
import {IcdProgramTimingComponent} from './components/icd-program-timing/icd-program-timing.component';
import {EsciComponentGridComponent} from './components/esci-component-grid/esci-component-grid.component';
import {ConfigurationComponent} from './components/configuration/configuration.component';
import {ChangeRolesComponent} from './components/change-roles/change-roles.component';
import {ListManagerComponent} from './components/list-manager/list-manager.component';
import {WorkloadTimingComponent} from './components/workload-timing/workload-timing.component';
import {
    UrlRequestActivityReportComponent
} from './components/url-request-activity-report/url-request-activity-report.component';
import {ClearCachesComponent} from './components/clear-caches/clear-caches.component';
import {ReleaseScheduleComponent} from './components/release-schedule/release-schedule.component';
import {IcdSubscriptionsComponent} from './components/icd-subscriptions/icd-subscriptions.component';
import {CapitalComponentUsageComponent} from './components/capital-component-usage/capital-component-usage.component';
import {Crm2Component} from './components/crm2/crm2.component';
import {IoMatrixComponent} from './components/io-matrix-workflow/io-matrix/io-matrix.component';
import {IoMatrixIcdsComponent} from './components/io-matrix-workflow/io-matrix-icds/io-matrix-icds.component';
import {CreateIcdsComponent} from './components/io-matrix-workflow/create-icds/create-icds.component';
import {AggregatorSignalTableComponent} from './components/aggregator-signal-table/aggregator-signal-table.component';
import {AggregatorIoMatrixComponent} from './components/aggregator-io-matrix/aggregator-io-matrix.component';

const routes: Routes = [
  {
    path: '',
    component: WelcomeComponent,
    data: { title: 'home' },
  },
  {
    path: 'buildCheckTool',
    component: BuildCheckToolComponent,
    data: { title: 'build-check-tool' },
  },
  {
    path: 'crm2',
    component: Crm2Component,
    data: { title: 'crm2' },
  },
  {
    path: 'netlistCompare',
    component: NetlistCompareComponent,
    data: { title: 'netlist-compare' },
  },
  {
    path: 'identicalConnector',
    component: IdenticalConnectorComponent,
    data: { title: 'identical-connector' },
  },
  {
    path: 'extractionCompare',
    component: ExtractionCompareComponent,
    data: { title: 'extraction-compare' },
  },
  {
    path: 'listManagement',
    component: ListManagerComponent,
    data: { title: 'list-management' },
  },
  {
    path: 'kts',
    component: KtsComponent,
    data: { title: 'key-task-scheduler' },
  },
  {
    path: 'programRuns',
    component: ProgramRunsComponent,
    data: { title: 'program-runs' },
  },
  {
    path: 'ktsEditor',
    component: KtsEditorComponent,
    data: { title: 'kts-editor' },
  },
  {
    path: 'ktsAdmin',
    component: KtsAdminComponent,
    data: { title: 'kts-admin' },
  },
  {
    path: 'vehicleBuildCompare',
    component: VehicleBuildCompareComponent,
    data: { title: 'vehicle-build-compare' },
  },
  {
    path: 'gpsRpoManagement',
    component: GpsRpoManagementComponent,
    data: { title: 'gps-rpo-management' },
  },
  {
    path: 'gpsTiming',
    component: GpsTimingComponent,
    data: { title: 'gps-timing' },
  },
  {
    path: 'restrictedPrograms',
    component: RestrictedProgramsComponent,
    data: { title: 'restricted-programs' },
  },
  {
    path: 'icdProgramTiming',
    component: IcdProgramTimingComponent,
    data: { title: 'icd-program-timing' },
  },
  {
    path: 'workloadTiming',
    component: WorkloadTimingComponent,
    data: { title: 'workload-timing' },
  },
  {
    path: 'esciComponentGrid/:componentName',
    component: EsciComponentGridComponent,
    data: { title: 'esci-component-grid' },
  },
  {
    path: 'esciConfiguration',
    component: ConfigurationComponent,
    data: { title: 'esci-configuration-grid' },
  },
  {
    path: 'changeRoles',
    component: ChangeRolesComponent,
    data: { title: 'change-roles' },
  },
  {
    path: 'backToEsci',
    component: BackToEsciComponent,
  },
  {
    path: 'urlRequestActivityReport',
    component: UrlRequestActivityReportComponent,
    data: { title: 'url-request-activity-report' },
  },
  {
    path: 'clearCaches',
    component: ClearCachesComponent,
    data: { title: 'clear-caches' },
  },
  {
    path: 'ioMatrix',
    component: IoMatrixComponent,
    data: { title: 'powertrain-io-matrix' },
  },
  {
    path: 'ioMatrixIcds',
    component: IoMatrixIcdsComponent,
    data: { title: 'io-matrix-icds' },
  },
  {
    path: 'createIcds',
    component: CreateIcdsComponent,
    data: { title: 'create-icds', matrixType: 'powertrain' },
  },
  {
    path: 'createAggregatorIcds',
    component: CreateIcdsComponent,
    data: { title: 'create-aggregator-icds', matrixType: 'aggregator' },
  },
  {
    path: 'icdIoMatrix',
    redirectTo: 'ioMatrix',
    pathMatch: 'full'
  },
  {
    path: 'releaseSchedule',
    component: ReleaseScheduleComponent,
    data: { title: 'release-schedule' },
  },
  {
    path: 'icdSubscriptions',
    component: IcdSubscriptionsComponent,
    data: { title: 'icd-subscriptions' },
  },
  {
    path: 'capitalComponentUsage',
    component: CapitalComponentUsageComponent,
    data: { title: 'capital-component-usage' },
  },
  {
    path: 'aggregatorSignal',
    component: AggregatorSignalTableComponent,
    data: { title: 'aggregator-signal-table' },
  },
  {
    path: 'aggregatorIoMatrix',
    component: AggregatorIoMatrixComponent,
    data: { title: 'aggregator-io-matrix' },
  },

  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
